export const DIGIT_ZEROS = [0xff10, 0x0660, 0x06f0];

export const NON_ASCII_DIGIT_REGEX = /[０-９٠-٩۰-۹]/g;

export const FULL_WIDTH_COLON_REGEX = /：/g;

export const TIME_OF_DAY_REGEX = /^(\d{1,2})(?:[:.h]?(\d{2})|h)?(?:([ap])\.?(?:m\.?)?)?$/;
